import { useFutureMeetingsQuery } from '../services';

import useAuthStore from '../store/auth';
import useCompanyStore from '../store/companies';

export function useFutureMeetings(searchForMeetings = '') {
  const user = useAuthStore(state => state.user);
  const selectedCompany = useCompanyStore(state => state.selectedCompany);

  // const {
  //   fetchNextPage,
  //   hasNextPage,
  //   isFetchingNextPage: isLoading,
  //   isLoading: isMainLoading,
  //   data: listOfFutureMeetings,
  //   status,
  //   error,
  // } = useInfiniteQuery(
  //   ['future'],
  //   ({ pageParam = 1 }) =>
  //     getFutureMeetingsRequest(
  //       user?.id as string,
  //       selectedCompany?.id as string,
  //       searchForMeetings,
  //       String(pageParam),
  //     ),
  //   {
  //     getNextPageParam: (lastPage: any, allPages: any[]) => {
  //       return lastPage?.length ? allPages.length + 1 : undefined;
  //     },
  //   },
  // );

  const {
    isLoading,
    data: listOfFutureMeetings,
    status,
    error,
  } = useFutureMeetingsQuery(
    user?.id as string,
    selectedCompany?.id as string,
    searchForMeetings,
    '1',
  );

  return {
    isLoading,
    listOfFutureMeetings,
    status,
    error,
  };
}
